module.exports = __webpack_public_path__ + "media/images/icon__point--text@3x-8cea4fe77c8a9c3f72281ca990c0029f.png";